import { render, staticRenderFns } from "./editaddress.vue?vue&type=template&id=2cbd33dc&scoped=true"
import script from "./editaddress.vue?vue&type=script&lang=js"
export * from "./editaddress.vue?vue&type=script&lang=js"
import style0 from "./editaddress.vue?vue&type=style&index=0&id=2cbd33dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd33dc",
  null
  
)

export default component.exports